/**
 * skipWindow
 * 配列の要素を指定のサイズで区切って重複無しの配列として返す
 *
 * @param array 処理対象の要素
 * @param windowSize 区切る要素数
 * @param includeRemainder 最後に中途半端な要素数のものができた場合、それを結果に含めるか
 *
 * skipWindow([1,2,3,4,5,6,7,8,9,10], 4, true)
 * -> [[1,2,3,4], [5,6,7,8], [9,10]]
 */
export const skipWindow = <T>(
  array: T[],
  windowSize: number,
  includeRemainder = true
): T[][] => {
  if (windowSize <= 0) throw new Error("windowSizeは正の整数で指定します");

  const result: T[][] = [];
  for (let i = 0; i < array.length; i += windowSize) {
    const item = array.slice(i, i + windowSize);
    if (item.length < windowSize && !includeRemainder) continue;
    result.push(item);
  }

  return result;
};
